import styled, { css } from 'styled-components';
import eyeIcon from '~/assets/icons/eye.svg';
import { ErrorBanner } from '../ErrorBanner';

const StyledPasswordEye = styled.span`
	position: absolute;
	right: 20px;
	top: 15px;
	width: 20px;
	height: 20px;
	background-color: rgba(255, 255, 255, 0.5);
	mask-image: url(${eyeIcon});
	mask-position: center;
	mask-repeat: no-repeat;
	-webkit-mask-image: url(${eyeIcon});
	-webkit-mask-position: center;
	-webkit-mask-repeat: no-repeat;
	transition: background-color 0.25s ease;
	cursor: pointer;
`;

const StyledLangImage = styled.img`
	position: absolute;
	top: 50%;
	transform: translateY(-50%);
	user-select: none;
	pointer-events: none;
	opacity: 0;
	transition: opacity 0.25s ease;
`;

const StyledContainer = styled.div<{
	$invalid: boolean;
}>`
	position: relative;
	width: 400px;
	height: 50px;
	display: flex;
	user-select: none;

	&:not(:focus-within)::before {
		${({ $invalid }) =>
			$invalid &&
			css`
				background-color: #c71e1e !important;
			`}
	}

	&:focus-within {
		${StyledLangImage} {
			opacity: 0.25;
		}
	}

	&:hover,
	&:focus-within {
		&::before {
			background-color: #000;
		}

		input {
			color: #000;
			background-color: #fff;
			outline: none;

			&::placeholder {
				color: rgba(0, 0, 0, 0.25);
			}
		}

		${StyledPasswordEye} {
			background-color: #000;
		}
	}

	${ErrorBanner} {
		position: absolute;
		top: 50%;
		right: -20px;
		transform: translate(100%, -50%);
	}

	${({ $invalid }) =>
		$invalid &&
		css`
			input:not(:focus) {
				color: #c71e1e;
				background-color: rgba(199, 30, 30, 0.25);
				border: 1px solid rgba(199, 30, 30, 0.5);

				&::placeholder,
				&:hover::placeholder {
					color: #c71e1e;
				}
			}

			${StyledPasswordEye},
			&:hover:not(:focus-within) ${StyledPasswordEye} {
				background-color: #c71e1e;
			}
		`}
`;

export { StyledContainer, StyledLangImage, StyledPasswordEye };
